import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43fbefd7"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"color":"#D9001B","margin-left":"10px"}
}
const _hoisted_2 = {
  key: 1,
  style: {"color":"#D9001B","margin-left":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("a", {
        target: "_blank",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.helpDoc && _ctx.helpDoc(...args)))
      }, "帮助中心")
    ]),
    _createVNode(_component_a_dropdown, null, {
      overlay: _withCtx(() => [
        _createVNode(_component_a_menu, { onClick: _ctx.onMenuClick }, {
          default: _withCtx(() => [
            _createVNode(_component_a_menu_item, { key: "userinfo" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('index-layout.topmenu.userinfo')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, { key: "logout" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('index-layout.topmenu.logout')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("a", {
          class: "indexlayout-top-usermenu ant-dropdown-link",
          onClick: _cache[1] || (_cache[1] = e => e.preventDefault())
        }, [
          _createTextVNode(_toDisplayString(_ctx.currentUser.email) + " ", 1),
          _createVNode(_component_DownOutlined)
        ])
      ]),
      _: 1
    }),
    (_ctx.currentUser.certStatus==1||_ctx.currentUser.certStatus == 2||_ctx.currentUser.certStatus == 4)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "(" + _toDisplayString(_ctx.t('index-layout.topmenu.notcertified')) + ")", 1))
      : _createCommentVNode("", true),
    (_ctx.currentUser.certStatus==3&&_ctx.currentUser.contStatus !== 3)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, "合同未签署"))
      : _createCommentVNode("", true)
  ], 64))
}